// src/pages/Reports.js
import React, { useEffect, useState } from 'react';
import { getSummary, getPipeline, getFinanceReport } from '../services/api';
import { T, fmt, Card, StatCard, Empty, Spinner, SectionTitle, STATUS_COLOR } from '../components/UI';

export default function Reports() {
  const [summary,  setSummary]  = useState(null);
  const [pipeline, setPipeline] = useState([]);
  const [finance,  setFinance]  = useState(null);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    Promise.all([getSummary(), getPipeline(), getFinanceReport()])
      .then(([s,p,f]) => { setSummary(s.data.data); setPipeline(p.data.data); setFinance(f.data.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;
  const s = summary || {};
  const t = finance?.totals || {};

  return (
    <div>
      <SectionTitle sub="Real-time business intelligence">Reports & Analytics</SectionTitle>

      <div style={{ display:'flex', gap:'14px', flexWrap:'wrap', marginBottom:'20px' }}>
        <StatCard label="Total Orders"    value={s.totalOrders||0} />
        <StatCard label="Total Collected" value={fmt(t.collected)} color={T.gold} />
        <StatCard label="Pending"         value={fmt(s.pendingAmount)} color={T.warning} />
        <StatCard label="Delivered"       value={s.deliveredCount||0} color={T.success} />
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px', marginBottom:'16px' }}>
        <Card>
          <div style={{ fontSize:'13px', fontWeight:700, color:T.gold, marginBottom:'14px' }}>📊 Financial Summary</div>
          {[
            ['Total Collected', fmt(t.collected), T.gold],
            [`Business Fund${t.collected > 0 ? ` (${Math.round((t.businessFund / t.collected) * 100)}%)` : ''}`, fmt(t.businessFund), T.success],
            [`Profit Pool${t.collected > 0 ? ` (${Math.round((t.profitPool / t.collected) * 100)}%)` : ''}`,   fmt(t.profitPool),   T.warning],
            [`Per Member Share (÷${t.profitPoolMembers || 5})`, fmt(t.perMember), '#5be3ff'],
            ['Pending Collection',  fmt(s.pendingAmount),T.danger],
          ].map(([k,v,c]) => (
            <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'9px 0', borderBottom:`1px solid ${T.border}` }}>
              <span style={{ fontSize:'13px', color:T.muted }}>{k}</span>
              <span style={{ fontSize:'13px', fontWeight:700, color:c }}>{v}</span>
            </div>
          ))}
        </Card>

        <Card>
          <div style={{ fontSize:'13px', fontWeight:700, color:T.gold, marginBottom:'14px' }}>📦 Order Metrics</div>
          {[
            ['Total Orders',     s.totalOrders||0],
            ['Delivered',        s.deliveredCount||0],
            ['Need Approval',    s.needApproval||0],
          ].map(([k,v]) => (
            <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'9px 0', borderBottom:`1px solid ${T.border}` }}>
              <span style={{ fontSize:'13px', color:T.muted }}>{k}</span>
              <span style={{ fontSize:'13px', fontWeight:700, color:T.text }}>{v}</span>
            </div>
          ))}
        </Card>
      </div>

      <Card>
        <div style={{ fontSize:'13px', fontWeight:700, color:T.gold, marginBottom:'14px' }}>🏆 Order Pipeline Overview</div>
        {pipeline.length === 0 ? <Empty msg="No orders yet." /> : (
          <div style={{ display:'flex', alignItems:'center', flexWrap:'wrap', gap:'4px' }}>
            {pipeline.map((p, i) => (
              <React.Fragment key={p.status}>
                <div style={{ background:`${STATUS_COLOR[p.status]||'#555'}22`, border:`1px solid ${STATUS_COLOR[p.status]||'#555'}44`, borderRadius:'8px', padding:'10px 14px', textAlign:'center', minWidth:'80px' }}>
                  <div style={{ fontSize:'20px', fontWeight:800, color:STATUS_COLOR[p.status]||'#999' }}>{p.count}</div>
                  <div style={{ fontSize:'10px', color:T.muted, marginTop:'2px', lineHeight:1.3 }}>{p.status.replace(/_/g,' ')}</div>
                </div>
                {i < pipeline.length-1 && <div style={{ color:T.border, fontSize:'16px' }}>›</div>}
              </React.Fragment>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
